import React, { ReactNode } from 'react';
import { Button } from '../Button';

interface BannerActionProps {
  children: ReactNode;
  onClick: () => void;
}

export const BannerAction: React.FC<BannerActionProps> = ({ children, onClick }) => (
  <Button data-component="BannerAction" variant="outline" size="x-small" onClick={onClick}>
    {children}
  </Button>
);
